export default __webpack_public_path__ + "static/media/camImg.e535fe6d.png";